import { useReducer } from 'react';
import { IBaseDetailPageContext } from '../context';

export type DetailPageActionType = 'change';
export interface IDetailPageAction {
  type: DetailPageActionType;
  payload: IBaseDetailPageContext;
}
function DetailPageAction(
  state: IBaseDetailPageContext,
  action: IDetailPageAction,
) {
  switch (action.type) {
    case 'change':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
const initDetailPage: IBaseDetailPageContext = {
  visible: false,
  // pageType: 'detail',
};
function useDetailPageContext() {
  const [DetailPageContext, dispatch] = useReducer(
    DetailPageAction,
    initDetailPage,
  );
  function dispatchDetailPage(
    type: DetailPageActionType,
    payload: IBaseDetailPageContext,
  ) {
    switch (type) {
      case 'change':
        dispatch({ type: 'change', payload });
        break;
    }
  }
  return {
    ...DetailPageContext,
    dispatchDetailPage,
  };
}

export default useDetailPageContext;
